import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import CancelIcon from '@mui/icons-material/Cancel';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CommentIcon from '@mui/icons-material/Comment';
import CreateNewFolderIcon from '@mui/icons-material/CreateNewFolder';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import DescriptionIcon from '@mui/icons-material/Description';
import EditIcon from '@mui/icons-material/Edit';
import FolderSharedIcon from '@mui/icons-material/FolderShared';
import LockIcon from '@mui/icons-material/Lock';
import MarkEmailUnreadIcon from '@mui/icons-material/MarkEmailUnread';
import MedicationIcon from '@mui/icons-material/Medication';
import PersonAddIcon from '@mui/icons-material/PersonAdd';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import SaveIcon from '@mui/icons-material/Save';
import SendIcon from '@mui/icons-material/Send';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import VolunteerActivismIcon from '@mui/icons-material/VolunteerActivism';
import React from 'react';

const icons = {
  accept: CheckCircleIcon,
  anonymize: VisibilityOffIcon,
  cancel: ArrowBackIcon,
  comment: CommentIcon,
  create_new_folder: CreateNewFolderIcon,
  delete: DeleteForeverIcon,
  edit: EditIcon,
  lock: LockIcon,
  mark_email_unread: MarkEmailUnreadIcon,
  medication: MedicationIcon,
  person_add: PersonAddIcon,
  picture_as_pdf: PictureAsPdfIcon,
  refuse: CancelIcon,
  save: SaveIcon,
  send: SendIcon,
  share: FolderSharedIcon,
  volunteer_activism: VolunteerActivismIcon,
  report: DescriptionIcon,
};

Object.entries(icons).forEach(([key, icon]) => {
  const IconComponent = icon;
  icons[key] = <IconComponent />;
});

/**
 *
 * @param {*} iconKey Material icon name, typically the snake case version
 * as visible on https://fonts.google.com/icons?selected=Material+Symbols
 * @returns
 */

export const getIconComponent = (iconKey) => {
  return icons[iconKey];
};

export default getIconComponent;
